var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._t("activator", null, {
    "attrs": {},
    "isNext": true,
    "on": {
      click: _vm.click
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }